import { QuestionOptions } from '../../../components/QuestionOptions';
import { QuestionDependencies, QuestionForm } from './components';
import { useQuestionDetails } from './hooks';

const QuestionDetails = () => {
  const {
    dependencies,
    translations,
    options,
    isOptionsLoading,
    questionHelpers: {
      autoTranslateText,
      form,
      question,
      isQuestionLoading,
      currentLanguage,
      initialValues,
      isEnglishTextDirty,
      isFormDirty,
      visibilityType,
      contextLanguage,
      questionText,
      handleEditQuestion,
      handleResetForm,
      setCurrentLanguage,
      setContextLanguage,
    },
  } = useQuestionDetails();

  return (
    <div className="pt-2 px-4 pb-16">
      <QuestionForm
        form={form}
        question={question}
        autoTranslateText={autoTranslateText}
        isFormDirty={isFormDirty}
        isEnglishTextDirty={isEnglishTextDirty}
        contextLanguage={contextLanguage}
        initialValues={initialValues}
        currentLanguage={currentLanguage}
        translations={translations?.items}
        isQuestionLoading={isQuestionLoading}
        hasDependencies={!!dependencies?.sources?.length}
        handleResetForm={handleResetForm}
        handleEditQuestion={handleEditQuestion}
        setCurrentLanguage={setCurrentLanguage}
        setContextLanguage={setContextLanguage}
      />
      {!!options?.count && <QuestionOptions options={options} isLoading={isOptionsLoading} />}
      <QuestionDependencies
        form={form}
        isFormDirty={isFormDirty}
        questionText={questionText}
        dependencies={dependencies}
        visibilityType={visibilityType}
        answerType={question?.answerType}
        handleEditQuestion={handleEditQuestion}
      />
    </div>
  );
};

export default QuestionDetails;
